// removed by extract-text-webpack-plugin
module.exports = {"gif":"Gf47927"};